import React, { useEffect, useState } from "react";
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  IconButton,
  Image,
  HStack,
  Flex,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  Text,
  ModalCloseButton,
  useDisclosure,
  Box,
  Grid,
} from "@chakra-ui/react";
import deleteBlueBtn from "../../assets/waveflowmain/deleteBluebTn.png";
import playBluebTn from "../../assets/waveflowmain/playBluebTn.png";
import {
  deletedeleteworkflow,
  DeployApi,
  GettingAllWorkFlow,
  runWorkFlowAdmin,
} from "../../allApi/api";
import { Button } from "react-bootstrap";
import DownLoadWorkFlowAdmin from "../../components/DownLoadBtn/DownLoadWorkFlowAdmin";
import ChatHistory from "./ChatHistory";
import PlayComp from "./PlayComp";
import chatbot_agentPhoto from "../../assets/waveflowmain/chatbot_agentPhoto.png";
import { commonStyle } from "../../styles/commonStyle";
import CreatingAgentSequenceLoader from "../../components/loader/RunSequnceLoader";
import { waveflowWorkflowAdminscreenData } from "../../redux/reducer/waveFlow";
import { useDispatch, useSelector } from "react-redux";
import { RefreshCcw } from "lucide-react";
import WorkflowCard from "./Workflow";

const WorkFlowAdmin = ({ setworkflowNumber }) => {
  const [hoveredRow, setHoveredRow] = useState(null);
  const [allworkflowData, setAllWorkflowData] = useState([]);
  const [loader, Setloader] = useState(true);
  const [deleteState, setDeleteState] = useState("");
  const [workFlowLoading, setWorkFlowLoading] = useState(false);
  const [runLoader, setRunLoader] = useState(false);
  const workflowsList = useSelector(
    (state) => state?.waveflowSearchData?.workflowAdminList
  );
  const isFetchWorkflow = useSelector(
    (state) => state?.waveflowSearchData?.isFetchWorkflow
  );
  const dispatch = useDispatch();
  const {
    isOpen: isModalplayOpen,
    onOpen: onModalplayOpen,
    onClose: onModalplayClose,
  } = useDisclosure();

  const {
    isOpen: isModalChatOpen,
    onOpen: onModalChatOpen,
    onClose: onModalChatClose,
  } = useDisclosure();

  const {
    isOpen: isopenLoader,
    onOpen: onOpenLoader,
    onClose: onCloseLoader,
  } = useDisclosure();

  const [chathistory, setChatHistory] = useState([]);

  const onMouseHoverHandle = (index) => {
    setHoveredRow(index);
  };

  const onMouseLeaveHanle = () => {
    setHoveredRow(null);
  };

  const getAllWorkFlow = async () => {
    try {
      setWorkFlowLoading(true);
      const res = await GettingAllWorkFlow();
      setAllWorkflowData(res);
      dispatch(waveflowWorkflowAdminscreenData(res));
      setworkflowNumber(res);
    } catch (error) {
    } finally {
      setWorkFlowLoading(false);
    }
  };

  const truncateText = (text, charLimit) => {
    if (text?.length > charLimit) {
      return text?.slice(0, charLimit) + "...";
    }
    return text;
  };

  const chatHistoryHandle = async (id) => {
    setChatHistory(id);
    onModalChatOpen();
  };

  const playHistoryHandle = async (session_id) => {
    try {
      setRunLoader(true);
      onOpenLoader();
      const response = await runWorkFlowAdmin(session_id);
      setChatHistory(session_id);
      onModalplayOpen();
    } catch (error) {
      console.error("Error during submission:", error);
    } finally {
      setRunLoader(false);
      onCloseLoader();
    }
  };

  const playdeleteHandle = async (id) => {
    try {
      const res = await deletedeleteworkflow(id);
      console.log("responce-delete", res);
      setDeleteState(res?.message);
    } catch (error) {
      return error;
    }
  };

  const handleDeploy = async (name, desc, id) => {
    const payload = {
      flowname: name,
      flowDesc: desc,
      flowId: id,
    };
    try {
      const response = await DeployApi(payload);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (deleteState) {
      getAllWorkFlow();
    }
  }, [deleteState]);

  useEffect(() => {
    if (!isFetchWorkflow) {
      getAllWorkFlow();
    }
  }, [isFetchWorkflow]);

  useEffect(() => {
    getAllWorkFlow();
  }, []);

  if (workFlowLoading) {
    return (
      <Flex justify="center" align="center" height="100vh">
        <CreatingAgentSequenceLoader />
      </Flex>
    );
  }

  return (
    <Box
      w={"100%"}
      h={"100%"}
      overflowY="auto"
      sx={{ ...commonStyle.sx, scrollBehavior: "smooth" }}
    >
      <Flex justify="flex-end" mb={4} px={4}>
        <Button
          onClick={getAllWorkFlow}
          colorScheme="blue"
          size="sm"
          isLoading={workFlowLoading}
          loadingText="Refreshing"
        >
          <Flex direction="row" align="center" justify="center" gap={2}>
            <RefreshCcw size={15} />
            <Text fontSize="md" mt={0}>
              Refresh
            </Text>
          </Flex>
        </Button>
      </Flex>

      <Grid templateColumns="repeat(3, 1fr)" gap={2}>
        {workflowsList &&
          workflowsList.length > 0 &&
          workflowsList.map((ele, index) => (
            <WorkflowCard
              key={index}
              {...ele}
              handleDeploy={handleDeploy}
              chatHistoryHandle={chatHistoryHandle}
              playdeleteHandle={playdeleteHandle}
              playHistoryHandle={playHistoryHandle}
            />
          ))}
      </Grid>

      <Modal
        isCentered
        blockScrollOnMount={false}
        closeOnOverlayClick={false}
        isOpen={isModalChatOpen}
        onClose={onModalChatClose}
      >
        <ModalOverlay />
        <ModalContent w={["75%", "75%"]} maxW="75%">
          <ModalBody>
            <HStack mb={2} w={"100%"}>
              <HStack>
                <Image w={"25px"} src={chatbot_agentPhoto} />
                <Text fontWeight={500}>Chat History</Text>
              </HStack>
              <ModalCloseButton />
            </HStack>
            <ChatHistory sessionId={chathistory} />
          </ModalBody>
        </ModalContent>
      </Modal>
      <Modal
        isCentered
        blockScrollOnMount={false}
        closeOnOverlayClick={false}
        isOpen={isModalplayOpen}
        onClose={onModalplayClose}
      >
        <ModalOverlay />
        <ModalContent w={["75%", "75%"]} maxW="75%">
          <ModalBody>
            <HStack>
              <HStack>
                <Image w={"25px"} src={chatbot_agentPhoto} />
                <Text fontWeight={500}>Hi! How can I help you?</Text>
              </HStack>
              <ModalCloseButton />
            </HStack>
            <PlayComp sessionId={chathistory} />
          </ModalBody>
        </ModalContent>
      </Modal>

      {runLoader && (
        <Modal
          isCentered
          blockScrollOnMount={false}
          closeOnOverlayClick={false}
          isOpen={isopenLoader}
          onClose={onCloseLoader}
        >
          <ModalOverlay
            bg="rgba(255, 255, 255, 0.4)"
            // backdropFilter="blur(6px)"
          />
          <ModalContent
            bg="transparent"
            boxShadow="none"
            p={6}
            w={["100%"]}
            textAlign="center"
          >
            <ModalBody
              mt={"15%"}
              ml={"20%"}
              boxShadow={"none"}
              bg={"transparent"}
              w={"100%"}
              textAlign={"center"}
            >
              <CreatingAgentSequenceLoader />
            </ModalBody>
          </ModalContent>
        </Modal>
      )}
    </Box>
  );
};

export default WorkFlowAdmin;
